var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "addErrorContainer" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "errorModal",
            "content-class": "menu-bg-blue-transparent-modal",
            title: "Add New Error",
            "hide-footer": "",
          },
          on: {
            shown: function ($event) {
              return _vm.getPropValues()
            },
            hidden: function ($event) {
              _vm.snapshot = null
              _vm.capturingSnapshot = false
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function ({ close }) {
                return [
                  _c("div", { staticClass: "ae-header" }, [
                    _c(
                      "span",
                      { staticClass: "ae-header-icon" },
                      [
                        _c("fa", {
                          attrs: { icon: ["fas", "exclamation-triangle"] },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "ae-header-text" }, [
                      _c("h5", { staticClass: "ae-title" }, [
                        _vm._v("Add New Error"),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "ae-subtitle" }, [
                        _vm._v("Report a new error on the map"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ae-close",
                        attrs: { type: "button", title: "Close" },
                        on: {
                          click: function ($event) {
                            return close()
                          },
                        },
                      },
                      [_c("fa", { attrs: { icon: ["fas", "times"] } })],
                      1
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "col-sm-12" },
                [
                  _c(
                    "div",
                    { staticClass: "ae-info" },
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("span", { staticClass: "ae-info-item" }, [
                              _c("span", { staticClass: "ae-info-label" }, [
                                _vm._v("Region"),
                              ]),
                              _c("span", { staticClass: "ae-info-value" }, [
                                _vm._v(_vm._s(_vm.region)),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.country
                            ? _c("b-col", [
                                _c("span", { staticClass: "ae-info-item" }, [
                                  _c("span", { staticClass: "ae-info-label" }, [
                                    _vm._v("Country"),
                                  ]),
                                  _c("span", { staticClass: "ae-info-value" }, [
                                    _vm._v(_vm._s(_vm.country)),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.province
                            ? _c("b-col", [
                                _c("span", { staticClass: "ae-info-item" }, [
                                  _c("span", { staticClass: "ae-info-label" }, [
                                    _vm._v("Province"),
                                  ]),
                                  _c("span", { staticClass: "ae-info-value" }, [
                                    _vm._v(_vm._s(_vm.province)),
                                  ]),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("span", { staticClass: "ae-info-label" }, [
                                _vm._v("Longitude"),
                              ]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: { disabled: "", required: "" },
                                model: {
                                  value: this.errLong,
                                  callback: function ($$v) {
                                    _vm.$set(this, "errLong", $$v)
                                  },
                                  expression: "this.errLong",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("span", { staticClass: "ae-info-label" }, [
                                _vm._v("Latitude"),
                              ]),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: { disabled: "", required: "" },
                                model: {
                                  value: this.errLat,
                                  callback: function ($$v) {
                                    _vm.$set(this, "errLat", $$v)
                                  },
                                  expression: "this.errLat",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", [
                            _vm._v(" Layer "),
                            _c("b", { staticClass: "white-text" }, [
                              _vm._v("*"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            class: _vm.missingFields.layer ? "red" : "",
                            attrs: { options: _vm.layerOptions, required: "" },
                            model: {
                              value: _vm.selectedLayer,
                              callback: function ($$v) {
                                _vm.selectedLayer = $$v
                              },
                              expression: "selectedLayer",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("label", [
                            _vm._v(" Dataset "),
                            _c("b", { staticClass: "white-text" }, [
                              _vm._v("*"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            class: _vm.missingFields.dataset ? "red" : "",
                            attrs: {
                              options: _vm.modifiedReleases,
                              required: "",
                            },
                            model: {
                              value: _vm.selectedPartNumber,
                              callback: function ($$v) {
                                _vm.selectedPartNumber = $$v
                              },
                              expression: "selectedPartNumber",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        { attrs: { id: "layerTypeMultiSelect" } },
                        [
                          _c("label", [
                            _vm._v(" Layer Attribute "),
                            _c("b", { staticClass: "white-text" }, [
                              _vm._v("*"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("multiselect", {
                            attrs: {
                              "close-on-select": false,
                              disabled: !_vm.layerTypeEnabled,
                              multiple: true,
                              options: _vm.layerTypes,
                              placeholder: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "selection",
                                fn: function ({ values, isOpen }) {
                                  return [
                                    values.length && !isOpen
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "multiselect__single",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(values.length) +
                                                " " +
                                                _vm._s(
                                                  values.length > 1
                                                    ? "options"
                                                    : "option"
                                                ) +
                                                " selected\n                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                            model: {
                              value: _vm.selectedLayerType,
                              callback: function ($$v) {
                                _vm.selectedLayerType = $$v
                              },
                              expression: "selectedLayerType",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("label", [
                            _vm._v(" Error Type "),
                            _c("b", { staticClass: "white-text" }, [
                              _vm._v("*"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            class: _vm.missingFields.error_type ? "red" : "",
                            attrs: { options: _vm.errorTypes, required: "" },
                            model: {
                              value: _vm.selectedErrorType,
                              callback: function ($$v) {
                                _vm.selectedErrorType = $$v
                              },
                              expression: "selectedErrorType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", [
                            _vm._v(" Severity "),
                            _c("b", { staticClass: "white-text" }, [
                              _vm._v("*"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            class: _vm.missingFields.severity ? "red" : "",
                            attrs: {
                              options: _vm.severityOptions,
                              required: "",
                            },
                            model: {
                              value: _vm.errSeverity,
                              callback: function ($$v) {
                                _vm.errSeverity = $$v
                              },
                              expression: "errSeverity",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c("label", [
                            _vm._v(" Status "),
                            _c("b", { staticClass: "white-text" }, [
                              _vm._v("*"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("b-form-select", {
                            class: _vm.missingFields.status ? "red" : "",
                            attrs: { options: _vm.statusOptions, required: "" },
                            model: {
                              value: _vm.errStatus,
                              callback: function ($$v) {
                                _vm.errStatus = $$v
                              },
                              expression: "errStatus",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("label", [_vm._v(" PDT Issue ID ")]),
                          _vm._v(" "),
                          _c("b-form-input", {
                            staticStyle: { color: "#495057" },
                            attrs: { placeholder: "Issue ID", required: "" },
                            model: {
                              value: _vm.issue_id,
                              callback: function ($$v) {
                                _vm.issue_id = $$v
                              },
                              expression: "issue_id",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-col",
                        [
                          _c("label", [_vm._v(" Comments ")]),
                          _vm._v(" "),
                          _c("b-form-textarea", {
                            model: {
                              value: _vm.errComments,
                              callback: function ($$v) {
                                _vm.errComments = $$v
                              },
                              expression: "errComments",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c("b-col", [
                        _c(
                          "div",
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  size: "sm",
                                  variant: "outline-success",
                                  disabled: _vm.capturingSnapshot,
                                  title: "Screen Capture",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.captureScreenshot()
                                  },
                                },
                              },
                              [
                                _c("fa", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.capturingSnapshot,
                                      expression: "!capturingSnapshot",
                                    },
                                  ],
                                  attrs: { icon: ["fas", "camera"] },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.capturingSnapshot,
                                        expression: "capturingSnapshot",
                                      },
                                    ],
                                  },
                                  [_vm._v("Capturing...")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.snapshot
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "ml-2",
                                    attrs: {
                                      size: "sm",
                                      variant: "outline-danger",
                                      title: "Remove Screen Capture",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.snapshot = null
                                      },
                                    },
                                  },
                                  [
                                    _c("fa", {
                                      attrs: { icon: ["fas", "trash"] },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.snapshot
                          ? _c("div", { staticClass: "mt-2" }, [
                              _c("img", {
                                staticStyle: {
                                  "max-width": "100%",
                                  "max-height": "150px",
                                  border: "1px solid #ccc",
                                  "border-radius": "4px",
                                },
                                attrs: {
                                  src: _vm.snapshot,
                                  alt: "Error snapshot",
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-2" },
                    [
                      _c("b-col", [
                        _c(
                          "button",
                          {
                            staticClass: "drt-submit-btn",
                            on: {
                              click: function ($event) {
                                return _vm.submitError()
                              },
                            },
                          },
                          [_c("span", [_vm._v("Submit Error")])]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }